import "./Contact.module.css";
import TrendMitraNavigationHeader from "@/reusable_sections/Header";
import SupportPortal from "./sections/SupportPortal";
import TerminalFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <TrendMitraNavigationHeader />
      <SupportPortal />
      <TerminalFooter />
    </div>;
}